var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleNoneFillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8457 21.0469C16.3828 21.0469 20.9531 16.4766 20.9531 10.9492C20.9531 5.42188 16.373 0.851562 10.8359 0.851562C5.30859 0.851562 0.748047 5.42188 0.748047 10.9492C0.748047 16.4766 5.31836 21.0469 10.8457 21.0469ZM9.75195 15.7734C9.38086 15.7734 9.07812 15.6172 8.80469 15.2559L6.41211 12.3555C6.23633 12.1309 6.14844 11.9062 6.14844 11.6621C6.14844 11.1543 6.54883 10.7441 7.05664 10.7441C7.35938 10.7441 7.59375 10.8516 7.84766 11.1738L9.72266 13.5469L13.7461 7.10156C13.9609 6.75977 14.2344 6.59375 14.5469 6.59375C15.0449 6.59375 15.4941 6.93555 15.4941 7.45312C15.4941 7.67773 15.377 7.92188 15.2402 8.13672L10.6602 15.2559C10.4453 15.5977 10.123 15.7734 9.75195 15.7734Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleNoneFillIcon);
export default __webpack_public_path__ + "static/media/checkCircleNoneFillIcon.9dcc4f18.svg";
export { ForwardRef as ReactComponent };